export enum EnvironmentType {
  Config = "Config",
  Test = "Test",
  Prod = "Prod",
}

export class EnvironmentTypeHelper {
  static getEnvironmentType(value: number): EnvironmentType {
    switch (value) {
      case 1:
        return EnvironmentType.Config;
      case 2:
        return EnvironmentType.Test;
      case 3:
        return EnvironmentType.Prod;
      default:
        throw new Error("Invalid env");
    }
  }
}